// material-ui
import { useTheme } from '@mui/material/styles';
import Logo from '../logo/logo.svg'

// ==============================|| LOGO ICON SVG ||============================== //

export default function LogoIcon() {
  const theme = useTheme();

  return (
    <img src={Logo} alt="" srcset="" height={20} />
  );
}
